// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@flip/XDL/Utilities";
import { orderUploadErrorsModalStyles } from "@insite/content-library/Components/OrderUploadErrorsModal";
import { css } from "styled-components";

// XNG-Changes
orderUploadErrorsModalStyles.modal = {
    ...orderUploadErrorsModalStyles.modal,
    sizeVariant: "large",
};
orderUploadErrorsModalStyles.cancelUploadButton = {
    ...orderUploadErrorsModalStyles.cancelUploadButton,
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

orderUploadErrorsModalStyles.continueUploadButton = {
    ...orderUploadErrorsModalStyles.continueUploadButton,
    css: css`
        margin-left: 10px;
        ${xScreen("lte", "xs")} {
            margin-left: 0;
            margin-top: 10px;
            width: 100%;
        }
    `,
};
